import React from "react";

export const downloadSvg = (
  <svg
    width="16"
    height="16"
    viewBox="0 0 10 11"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M1.60009 10.4664C1.30036 10.4664 1.04756 10.3638 0.841692 10.1584C0.636358 9.95255 0.533691 9.69975 0.533691 9.40002V8.40002H1.40009V9.40002C1.40009 9.44429 1.42223 9.48882 1.46649 9.53362C1.51129 9.57789 1.55582 9.60002 1.60009 9.60002H8.40009C8.44436 9.60002 8.48889 9.57789 8.53369 9.53362C8.57796 9.48882 8.60009 9.44429 8.60009 9.40002V8.40002H9.46649V9.40002C9.46649 9.69975 9.36382 9.95255 9.15849 10.1584C8.95263 10.3638 8.69983 10.4664 8.40009 10.4664H1.60009ZM5.00009 8.15042L2.28329 5.43362L2.90009 4.81682L4.56649 6.48322V0.616821H5.43369V6.48322L7.10009 4.81682L7.71689 5.43362L5.00009 8.15042Z"
      fill="#ffffff"
    />
  </svg>
);
export const dataReceiptIConSvg = (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="12"
    height="12"
    viewBox="0 0 12 12"
    fill="none"
  >
    <path
      d="M6 5.33333C4.33333 5.33333 2.91667 5.07222 1.75 4.55C0.583333 4.02778 0 3.4 0 2.66667C0 1.93333 0.583333 1.30556 1.75 0.783333C2.91667 0.261111 4.33333 0 6 0C7.66667 0 9.08333 0.261111 10.25 0.783333C11.4167 1.30556 12 1.93333 12 2.66667C12 3.4 11.4167 4.02778 10.25 4.55C9.08333 5.07222 7.66667 5.33333 6 5.33333ZM6 8.66667C4.33333 8.66667 2.91667 8.40556 1.75 7.88333C0.583333 7.36111 0 6.73333 0 6V4.33333C0 4.82222 0.227778 5.23622 0.683333 5.57533C1.13889 5.914 1.68333 6.18889 2.31667 6.4C2.95 6.61111 3.60844 6.76378 4.292 6.858C4.97511 6.95267 5.54444 7 6 7C6.45556 7 7.02489 6.95267 7.708 6.858C8.39156 6.76378 9.05 6.61111 9.68333 6.4C10.3167 6.18889 10.8611 5.914 11.3167 5.57533C11.7722 5.23622 12 4.82222 12 4.33333V6C12 6.73333 11.4167 7.36111 10.25 7.88333C9.08333 8.40556 7.66667 8.66667 6 8.66667ZM6 12C4.33333 12 2.91667 11.7389 1.75 11.2167C0.583333 10.6944 0 10.0667 0 9.33333V7.66667C0 8.15556 0.227778 8.56956 0.683333 8.90867C1.13889 9.24733 1.68333 9.52222 2.31667 9.73333C2.95 9.94444 3.60844 10.0973 4.292 10.192C4.97511 10.2862 5.54444 10.3333 6 10.3333C6.45556 10.3333 7.02489 10.2862 7.708 10.192C8.39156 10.0973 9.05 9.94444 9.68333 9.73333C10.3167 9.52222 10.8611 9.24733 11.3167 8.90867C11.7722 8.56956 12 8.15556 12 7.66667V9.33333C12 10.0667 11.4167 10.6944 10.25 11.2167C9.08333 11.7389 7.66667 12 6 12Z"
      fill="#4B5763"
    />
    <path
      xmlns="http://www.w3.org/2000/svg"
      d="M6 5.33333C4.33333 5.33333 2.91667 5.07222 1.75 4.55C0.583333 4.02778 0 3.4 0 2.66667C0 1.93333 0.583333 1.30556 1.75 0.783333C2.91667 0.261111 4.33333 0 6 0C7.66667 0 9.08333 0.261111 10.25 0.783333C11.4167 1.30556 12 1.93333 12 2.66667C12 3.4 11.4167 4.02778 10.25 4.55C9.08333 5.07222 7.66667 5.33333 6 5.33333ZM6 8.66667C4.33333 8.66667 2.91667 8.40556 1.75 7.88333C0.583333 7.36111 0 6.73333 0 6V4.33333C0 4.82222 0.227778 5.23622 0.683333 5.57533C1.13889 5.914 1.68333 6.18889 2.31667 6.4C2.95 6.61111 3.60844 6.76378 4.292 6.858C4.97511 6.95267 5.54444 7 6 7C6.45556 7 7.02489 6.95267 7.708 6.858C8.39156 6.76378 9.05 6.61111 9.68333 6.4C10.3167 6.18889 10.8611 5.914 11.3167 5.57533C11.7722 5.23622 12 4.82222 12 4.33333V6C12 6.73333 11.4167 7.36111 10.25 7.88333C9.08333 8.40556 7.66667 8.66667 6 8.66667ZM6 12C4.33333 12 2.91667 11.7389 1.75 11.2167C0.583333 10.6944 0 10.0667 0 9.33333V7.66667C0 8.15556 0.227778 8.56956 0.683333 8.90867C1.13889 9.24733 1.68333 9.52222 2.31667 9.73333C2.95 9.94444 3.60844 10.0973 4.292 10.192C4.97511 10.2862 5.54444 10.3333 6 10.3333C6.45556 10.3333 7.02489 10.2862 7.708 10.192C8.39156 10.0973 9.05 9.94444 9.68333 9.73333C10.3167 9.52222 10.8611 9.24733 11.3167 8.90867C11.7722 8.56956 12 8.15556 12 7.66667V9.33333C12 10.0667 11.4167 10.6944 10.25 11.2167C9.08333 11.7389 7.66667 12 6 12Z"
      fill="#4B5763"
    />
  </svg>
);
export const envIconDataReceiptSvg = (
  <svg
    width="172"
    height="169"
    viewBox="0 0 172 169"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M111.716 69.5991V99.3407L86.0005 114.181V84.4396L111.716 69.5991Z"
      fill="#F78D2C"
    />
    <path
      d="M111.715 69.5993L86.0003 84.4398L60.2246 69.5993L86.0003 54.7588L111.715 69.5993Z"
      fill="#FAAF70"
    />
    <path
      d="M86.0003 84.4396V114.181L60.2246 99.3407V69.5991L86.0003 84.4396Z"
      fill="#CC8B5A"
    />
    <path d="M86.6066 19.3232H85.333V54.7587H86.6066V19.3232Z" fill="#BFBFBF" />
    <path
      d="M59.9143 98.8245L29.1606 116.493L29.7957 117.595L60.5493 99.9271L59.9143 98.8245Z"
      fill="#BFBFBF"
    />
    <path
      d="M112.066 98.832L111.43 99.9341L142.17 117.631L142.806 116.528L112.066 98.832Z"
      fill="#BFBFBF"
    />
    <path
      d="M86.0002 151.616L27.7773 118.058V50.9425L86.0002 17.3848L144.223 50.9425V118.058L86.0002 151.616ZM31.2343 116.059L86.0002 147.678H86.0608L140.766 116.12V52.9414L86.0002 21.3826L31.2343 52.9414V116.059Z"
      fill="black"
    />
    <path
      d="M87.6984 147.497H84.2414V85.4695L28.6265 53.4261L30.3246 50.458L87.6984 83.4706V147.497Z"
      fill="black"
    />
    <path
      d="M141.608 50.4255L85.1143 82.9316L86.84 85.9234L143.334 53.4172L141.608 50.4255Z"
      fill="black"
    />
  </svg>
);
export const copyIconDataReceiptSvg = (
  <svg
    width="13"
    height="16"
    viewBox="0 0 13 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M1.75 15.5C1.3375 15.5 0.98425 15.3532 0.69025 15.0597C0.39675 14.7657 0.25 14.4125 0.25 14V3.5H1.75V14H10V15.5H1.75ZM4.75 12.5C4.3375 12.5 3.9845 12.3532 3.691 12.0597C3.397 11.7657 3.25 11.4125 3.25 11V2C3.25 1.5875 3.397 1.23425 3.691 0.94025C3.9845 0.64675 4.3375 0.5 4.75 0.5H11.5C11.9125 0.5 12.2657 0.64675 12.5597 0.94025C12.8533 1.23425 13 1.5875 13 2V11C13 11.4125 12.8533 11.7657 12.5597 12.0597C12.2657 12.3532 11.9125 12.5 11.5 12.5H4.75ZM4.75 11H11.5V2H4.75V11Z"
      fill="#4B5763"
    />
  </svg>
);
export const viewIconDataReceiptSvg = (
  <svg
    width="17"
    height="17"
    viewBox="0 0 14 10"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M6.99998 7.51677C7.69972 7.51677 8.29412 7.27224 8.78318 6.78317C9.27225 6.2941 9.51678 5.6997 9.51678 4.99997C9.51678 4.30024 9.27225 3.70584 8.78318 3.21677C8.29412 2.7277 7.69972 2.48317 6.99998 2.48317C6.30025 2.48317 5.70585 2.7277 5.21678 3.21677C4.72772 3.70584 4.48318 4.30024 4.48318 4.99997C4.48318 5.6997 4.72772 6.2941 5.21678 6.78317C5.70585 7.27224 6.30025 7.51677 6.99998 7.51677ZM6.99998 6.59997C6.55572 6.59997 6.17785 6.4445 5.86638 6.13357C5.55545 5.8221 5.39998 5.44424 5.39998 4.99997C5.39998 4.5557 5.55545 4.17784 5.86638 3.86637C6.17785 3.55544 6.55572 3.39997 6.99998 3.39997C7.44425 3.39997 7.82211 3.55544 8.13358 3.86637C8.44452 4.17784 8.59998 4.5557 8.59998 4.99997C8.59998 5.44424 8.44452 5.8221 8.13358 6.13357C7.82211 6.4445 7.44425 6.59997 6.99998 6.59997ZM6.99998 9.46637C5.50025 9.46637 4.13625 9.06077 2.90798 8.24957C1.68025 7.4389 0.766382 6.3557 0.166382 4.99997C0.766382 3.64424 1.68025 2.56104 2.90798 1.75037C4.13625 0.93917 5.50025 0.533569 6.99998 0.533569C8.49971 0.533569 9.86372 0.93917 11.092 1.75037C12.3197 2.56104 13.2336 3.64424 13.8336 4.99997C13.2336 6.3557 12.3197 7.4389 11.092 8.24957C9.86372 9.06077 8.49971 9.46637 6.99998 9.46637Z"
      fill="#8B939D"
    />
  </svg>
);
export const downloadDataReceiptSvg = (
  <svg
    width="17"
    height="17"
    viewBox="0 0 10 11"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M1.60009 10.4664C1.30036 10.4664 1.04756 10.3638 0.841692 10.1584C0.636358 9.95255 0.533691 9.69975 0.533691 9.40002V8.40002H1.40009V9.40002C1.40009 9.44429 1.42223 9.48882 1.46649 9.53362C1.51129 9.57789 1.55582 9.60002 1.60009 9.60002H8.40009C8.44436 9.60002 8.48889 9.57789 8.53369 9.53362C8.57796 9.48882 8.60009 9.44429 8.60009 9.40002V8.40002H9.46649V9.40002C9.46649 9.69975 9.36382 9.95255 9.15849 10.1584C8.95263 10.3638 8.69983 10.4664 8.40009 10.4664H1.60009ZM5.00009 8.15042L2.28329 5.43362L2.90009 4.81682L4.56649 6.48322V0.616821H5.43369V6.48322L7.10009 4.81682L7.71689 5.43362L5.00009 8.15042Z"
      fill="#8B939D"
    />
  </svg>
);
